"use strict";

var _defineProperty = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/defineProperty.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getRequiredDef(keyword) {
  return function () {
    return {
      keyword: keyword,
      type: "object",
      schemaType: "array",
      macro: function macro(schema) {
        if (schema.length === 0) return true;
        if (schema.length === 1) return {
          required: schema
        };
        var comb = keyword === "anyRequired" ? "anyOf" : "oneOf";
        return _defineProperty({}, comb, schema.map(function (p) {
          return {
            required: [p]
          };
        }));
      },
      metaSchema: {
        type: "array",
        items: {
          type: "string"
        }
      }
    };
  };
}

exports.default = getRequiredDef;